import { render, staticRenderFns } from "./CreditLimitRequestList.vue?vue&type=template&id=24ebf1e5&scoped=true&"
import script from "./CreditLimitRequestList.vue?vue&type=script&lang=js&"
export * from "./CreditLimitRequestList.vue?vue&type=script&lang=js&"
import style0 from "./CreditLimitRequestList.vue?vue&type=style&index=0&id=24ebf1e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebf1e5",
  null
  
)

export default component.exports